import React, {useState} from 'react'
import { default as NumberFormat } from 'react-number-format';
import AdditionalItems from './AdditionalItems';


const Form = ({handleFormChange, contactInfo, disclaimers, logos}) =>{

	const [optional, setOptional] = useState(false);

	return(
		<div>
			<div className="row">
				<div className="column medium-4">
					<fieldset>
						<legend>Basic Information</legend>
						<label>
							Name <input type="text" name="name" 
							onChange={handleFormChange}
							value={contactInfo.name} />
						</label>
						<label>
							Pronouns <input type="text" name="pronouns" 
							onChange={handleFormChange}
							value={contactInfo.pronouns} />
						</label>
						<label>
							Title <input type="text" name="title" 
							onChange={handleFormChange}
							value={contactInfo.title} />
						</label>
						<label>
							Department <input type="text" name="department" 
							onChange={handleFormChange}
							value={contactInfo.department} />
						</label>
						<label>
							URL <input type="text" name="url"
							onChange={handleFormChange}
							value={contactInfo.url} />
						</label>
					</fieldset>
				</div>
				<div className="column medium-4">
					<fieldset>
						<legend>Location</legend>
						<label>
							Building <input type="text" name="building" 
							onChange={handleFormChange}
							value={contactInfo.building} />
						</label>
						<label>
							Address <input type="text" name="address" 
							onChange={handleFormChange}
							value={contactInfo.address} />
						</label>
						<label>
							Campus Box <input type="text" name="campusbox" 
							onChange={handleFormChange}
							value={contactInfo.campusbox} />
						</label>
						<label>
							City, State, Zip
							<input name="city" type="text" 
							onChange={handleFormChange}
							value={contactInfo.city} />
						</label>
					</fieldset>
				</div>
				<div className="column medium-4">
					<fieldset>
						<legend>Contact </legend>
						<label>
							Office Phone
							<NumberFormat 
								name="phoneoffice" 
								onChange={handleFormChange}
								value={contactInfo.phoneoffice} 
								placeholder="970-351-XXXX"
								format="###-###-####" mask="_"/>
						</label>
						<label>
							Cell Phone (optional)
							<NumberFormat 
								name="phonecell" 
								onChange={handleFormChange}
								value={contactInfo.phonecell}
								placeholder="970-351-XXXX"
								format="###-###-####" mask="_" />
						</label>
						<label>
							Fax (optional)
							<NumberFormat 
							name="phonefax" 
							onChange={handleFormChange}
							value={contactInfo.phonefax} 
							placeholder="970-351-XXXX"
							format="###-###-####" mask="_" />
						</label>
					</fieldset>
					<fieldset>
						<legend>Image</legend>
						<label>
							Show Image (for <em>Stacked</em> and <em>Inline</em>)
							<select 
								name="image"
								onChange={handleFormChange}
								value={contactInfo.image}>
								<option value="Yes">Yes</option>
								<option value="No">No</option>
							</select>
						</label>
					</fieldset>
				</div>
			</div>
			<div className="row">
				<div className="medium-4 column">
					<button className={(optional) ? 'button full small active' : 'button full small'} onClick={()=>{ setOptional(!optional)} }>Additional Options</button>
				</div>
					<AdditionalItems
						contactInfo={contactInfo}
						handleFormChange={handleFormChange}
						disclaimers={disclaimers}
						logos={logos}
						visible={optional} />
			</div>
			<hr/>
		</div>

	)
}

export default Form;